import { render, staticRenderFns } from "./QScoreCardDigitalLeads.vue?vue&type=template&id=2b19c57c&scoped=true&"
import script from "./QScoreCardDigitalLeads.vue?vue&type=script&lang=js&"
export * from "./QScoreCardDigitalLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19c57c",
  null
  
)

export default component.exports